import { PartnerHospitalTagCode } from "@/entities/hospital/api/types"

const TAG_LABEL: Record<PartnerHospitalTagCode, string> = {
  [PartnerHospitalTagCode.NIGHT_CARE]: "야간 진료",
  [PartnerHospitalTagCode.HOLIDAY_CARE]: "휴일 진료",
  [PartnerHospitalTagCode.EMERGENCY_CARE]: "응급 진료",
}

export function getPartnerHospitalTagLabel(code: PartnerHospitalTagCode) {
  return TAG_LABEL[code] ?? code
}